import { useIsFetching, useQuery, useQueryClient } from '@tanstack/react-query'
import getSession from '../next-api/session/session'
import { sessionKey } from './session.keys'

export const useSession = () => {
  return useQuery({
    queryKey: sessionKey,
    queryFn: getSession,
  })
}

export const useIsB2BUser = () => {
  const { data: session } = useSession()

  return session?.user.salesChannel.includes('B2B') ?? false
}

export const useUpdateSession = () => {
  const queryClient = useQueryClient()

  const update = () => {
    return queryClient.invalidateQueries({
      queryKey: sessionKey,
    })
  }

  const isLoading = useIsFetching({ queryKey: sessionKey })

  return {
    update,
    isLoading,
  }
}
